import React from "react";
import { Link } from "react-router-dom";
import { PATH_PRIVATE } from "../routes/paths";

interface Props {
  /**
   * Set on endpoints that never populate `errorCode` (currently Get Token),
   * so the page does not point readers at codes it will not return.
   */
  noErrorCode?: boolean;
}

/**
 * Compact pointer to the central Error Codes page. Endpoint pages use this
 * instead of rendering the whole catalogue, which is maintained in one place.
 */
function ErrorCodesLink({ noErrorCode = false }: Props) {
  return (
    <div className="my-5">
      <h4 className="my-3">Error Handling</h4>
      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
        Failures use the same envelope as a success:{" "}
        <code>{`{ statusCode, message, errorCode, data }`}</code>.{" "}
        {noErrorCode ? (
          <>
            This endpoint does not return an <code>errorCode</code> &mdash; branch on
            the HTTP status and read <code>message</code>.
          </>
        ) : (
          <>
            Branch on <code>errorCode</code>, not on <code>message</code> &mdash;
            message wording may change, codes will not.
          </>
        )}
      </p>
      <Link to={PATH_PRIVATE.ErrorCodes} className="btn btn-outline-primary btn-sm">
        View all error codes
      </Link>
    </div>
  );
}

export default ErrorCodesLink;
